// 受付状態のデフォルト値を定義
export const DEFAULT_RECEPTION_STATUS = {
  status: 'stopped',    // 'active', 'stopped', 'maintenance'
  startTime: new Date(Date.now() - 5 * 60 * 60 * 1000), // 5時間前に停止開始
  totalOperationTime: 18 * 60 * 60 * 1000 + 12 * 60 * 1000, // 18時間12分の累計稼働時間
  todayOperationTime: 5 * 60 * 60 * 1000 + 12 * 60 * 1000  // 今日の稼働時間 5時間12分
}

// 有効な状態値
export const VALID_STATUSES = ['active', 'stopped', 'maintenance']

// localStorage用のキー名
export const RECEPTION_STATUS_KEY = 'alsok_receptionStatus'

// 受付状態をlocalStorageから読み込む関数
export const loadReceptionStatus = () => {
  try {
    const savedStatus = localStorage.getItem(RECEPTION_STATUS_KEY)
    if (savedStatus) {
      const parsed = JSON.parse(savedStatus)
      if (parsed.startTime) {
        parsed.startTime = new Date(parsed.startTime)
      }
      console.log('📋 localStorage: 受付状態を読み込み成功:', parsed)
      return parsed
    } else {
      console.log('📋 localStorage: 受付状態データがありません')
    }
  } catch (error) {
    console.error('❌ localStorage: 受付状態読み込みエラー:', error)
  }
  return null
}

// 受付状態をlocalStorageに保存する関数
export const saveReceptionStatus = (status) => {
  try {
    // 状態値のバリデーション
    if (status.status && !VALID_STATUSES.includes(status.status)) {
      console.warn('⚠️ localStorage: 無効な状態値:', status.status)
      status.status = 'stopped' // デフォルトに戻す
    }
    
    const statusJson = JSON.stringify(status)
    localStorage.setItem(RECEPTION_STATUS_KEY, statusJson)
    console.log('✅ localStorage: 受付状態保存成功:', status)
    console.log('📋 localStorage: 保存されたJSON:', statusJson)
    
    // 保存後の検証
    const verification = localStorage.getItem(RECEPTION_STATUS_KEY)
    if (verification === statusJson) {
      console.log('✅ localStorage: 保存検証成功')
    } else {
      console.error('❌ localStorage: 保存検証失敗')
    }
    
    return true
  } catch (error) {
    console.error('❌ localStorage: 受付状態保存エラー:', error)
    return false
  }
}